module.exports = __webpack_public_path__ + "img/input-logo.adc7126a.svg";